import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { ThemeProvider } from '@mui/material';
import { createAppTheme, getThemeVariables, THEME_COLORS } from '../theme';
import { customStorage } from '../services/CommonService';

const AppThemeContext = createContext({ themeName: 'teal', setThemeName: () => {} });
export const useAppTheme = () => useContext(AppThemeContext);
export function AppThemeProvider({ children }) {
    const [themeName, setName] = useState(() => {
        try { const saved = customStorage.persistent.getItem('pwf-theme'); return THEME_COLORS[saved] ? saved : 'teal'; }
        catch { return 'teal'; }
    });
    const setThemeName = name => { if (THEME_COLORS[name]) setName(name); };
    const theme = useMemo(() => createAppTheme(themeName), [themeName]);
    useLayoutEffect(() => {
        const variables = getThemeVariables(themeName);
        Object.entries(variables).forEach(([key, value]) => document.documentElement.style.setProperty(`--app-${key}`, value));
        document.documentElement.dataset.theme = themeName;
        try { customStorage.persistent.setItem('pwf-theme', themeName); } catch { /* Keep selection in memory if storage is unavailable. */ }
    }, [themeName]);
    return <AppThemeContext.Provider value={{ themeName, setThemeName }}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </AppThemeContext.Provider>;
}
